/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The four things a carrier looks for. Two are shipment states; the other
 * two are conditions we derive — whether an operational issue is open on
 * it, and whether its invoice is under audit.
 *
 * @export
 */
export const ShipmentStatusFilter = {
  All: "all",
  InTransit: "in_transit",
  Delivered: "delivered",
  IssueOpen: "issue_open",
  InAudit: "in_audit",
} as const;
export type ShipmentStatusFilter =
  (typeof ShipmentStatusFilter)[keyof typeof ShipmentStatusFilter];

export function instanceOfShipmentStatusFilter(value: any): boolean {
  for (const key in ShipmentStatusFilter) {
    if (Object.prototype.hasOwnProperty.call(ShipmentStatusFilter, key)) {
      if (
        ShipmentStatusFilter[key as keyof typeof ShipmentStatusFilter] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function ShipmentStatusFilterFromJSON(json: any): ShipmentStatusFilter {
  return ShipmentStatusFilterFromJSONTyped(json, false);
}

export function ShipmentStatusFilterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentStatusFilter {
  return json as ShipmentStatusFilter;
}

export function ShipmentStatusFilterToJSON(
  value?: ShipmentStatusFilter | null,
): any {
  return value as any;
}

export function ShipmentStatusFilterToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ShipmentStatusFilter {
  return value as ShipmentStatusFilter;
}
